/* Polsk katalog for locale-assets-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'err.purchase.invoiceNumberRequired': 'Wpisz numer faktury dostawcy przed zaksięgowaniem.',
  'err.supplierPayment.reverseUseFirst': 'Wycofaj zwrot i wykorzystanie nadpłaty, zanim wycofasz płatność.',
  'supplierPay.description': 'Płatność faktury dostawcy {number}',
  'supplierPay.total': 'Kwota faktury',
  'supplierPay.paid': 'Zapłacono / rozliczono',
  'supplierPay.remaining': 'Pozostało',
  'supplierPay.available': 'Nadpłata u dostawcy',
  'supplierPay.register': 'Zarejestruj płatność',
  'supplierPay.link': 'Powiąż istniejące księgowanie',
  'supplierPay.history': 'Historia płatności',
  'supplierPay.selectInvoice': 'Opłacana faktura',
  'supplierPay.noInvoice': 'Nie wybrano faktury',
  'supplierPay.overpayment': 'Nadwyżka {amount} pozostanie jako nadpłata u dostawcy.',
  'supplierPay.open': 'Otwarte',
  'supplierPay.openTotal': 'Nieopłacone faktury',
  'err.asset.reverseSaleBeforeAcquisition': 'Cofnij sprzedaż, zanim zmienisz lub anulujesz nabycie.',
  'asset.tabDrafts': 'Szkice ({n})',
  'asset.bookValueAtSale': 'Wartość księgowa na dzień sprzedaży',
  'asset.taxDepreciation': 'Amortyzacja podatkowa',
  'asset.bookTaxExplanation': 'Wartość księgowa wynika z planu amortyzacji aktywa. Wartość podatkowa jest obliczana osobno według grupy saldowej. Dane podatkowe dotyczą całej grupy, jeśli obejmuje ona kilka aktywów.',
  'asset.automationActivate': 'Aktywuj i zaksięguj',
  'asset.automationCatchUp': 'Sprawdź i zaksięguj zaległe',
  'asset.automationPause': 'Wstrzymaj automatyzację',
  'asset.automationConfirmEnable': 'Potwierdź i zaksięguj',
  'asset.automationConfirmAmount': 'Zatwierdzasz plany amortyzacji i księgujesz {amount} za zakończone miesiące do {date} włącznie. Następnie nowe zakończone miesiące będą księgowane automatycznie.',
  'asset.automationPauseExplanation': 'Przyszłe automatyczne księgowanie zostanie wstrzymane. Już zaksięgowane odpisy amortyzacyjne pozostają. Obowiązek amortyzacji nie znika; zaległe kwoty nadal trzeba zaksięgować.',
  'asset.automationEnabledSaved': 'Automatyzacja zatwierdzona, a zakończone miesiące zaksięgowane.',
  'asset.automationPausedSaved': 'Automatyzacja wstrzymana. Zaksięgowana amortyzacja została zachowana.',
  'asset.automationSaveFailed': 'Nie udało się potwierdzić zmiany. Sprawdź status, zanim spróbujesz ponownie.',
  'asset.automationPostingNotConfirmed': 'Księgowanie nie zostało potwierdzone. Sprawdź zaległe kwoty i dowody księgowe. Nie zakładaj, że amortyzacja została zaksięgowana tylko dlatego, że automatyzacja jest włączona.',
  'asset.automationBasisChanged': 'Podstawa uległa zmianie. Zamknij okno i ponownie sprawdź kwoty.',
  'asset.automationRequestUncertain': 'Serwer nie odpowiedział na czas. Księgowanie mogło zostać wykonane. Odśwież księgi i sprawdź dowody księgowe, zanim spróbujesz ponownie.',
  'asset.automationStatusAwaiting': 'Automatyzacja jest włączona. Nie zaksięgowano jeszcze żadnej amortyzacji.',
  'asset.postingReviewRequired': 'Wymaga uzgodnienia',
  'asset.projectedYearEndValue': 'Szacowana wartość na koniec roku (plan)',
  'asset.usefulLifeSuggestionHelp': 'Okres użytkowania to edytowalna propozycja oparta na grupie. Dostosuj go do przewidywanego użytkowania; nie jest to przepis podatkowy.',
  'asset.advancedOptions': 'Zaawansowane',
  'asset.advancedOptionsHelp': 'W razie potrzeby dostosuj okres użytkowania, wartość rezydualną lub dodatkowy odpis aktualizujący. Wartości domyślne są już wypełnione.',
  'asset.editAdjustments': 'Dostosuj',
  'asset.hideAdjustments': 'Ukryj',
  'asset.automaticPlanSummary': 'Okres użytkowania (lata): {years}. Wartość rezydualna: {residual}.',
  'asset.noExtraImpairmentDefault': 'Domyślnie brak dodatkowego odpisu aktualizującego.',
  'asset.optionalDocumentation': 'Dokumentacja / uzasadnienie (opcjonalnie)',
  'asset.title': 'Środki trwałe',
  'asset.subtitle': 'Sprzęt i wartości, które firma posiada przez dłuższy czas',
  'asset.new': 'Nowy środek trwały',
  'asset.info': 'Informacje',
  'asset.accounting': 'Księgowość',
  'asset.moreActions': 'Więcej działań',
  'asset.automationStatusTitle': 'Automatyczne księgowanie miesięczne',
  'asset.automationStatusActive': 'Aktywne. Ostatnie księgowanie do {date} włącznie.',
  'asset.automationStatusDefault': 'Domyślnie włączone. Nowe środki trwałe są księgowane automatycznie co miesiąc po rejestracji.',
  'asset.taxAutomaticTitle': 'Amortyzacja podatkowa jest obliczana automatycznie',
  'asset.taxAutomaticHelp': 'Plumme stosuje zwykłe przepisy podatkowe i proponuje kwoty za {year}. Zwykle nie musisz tu nic robić.',
  'asset.taxAutomaticDepreciation': 'Obliczona amortyzacja',
  'asset.taxAutomaticIncome': 'Obliczone ujęcie przychodu',
  'asset.taxAutomaticDeduction': 'Obliczone odliczenie straty',
  'asset.taxAdvancedChoices': 'Opcje zaawansowane',
  'asset.taxAdvancedHelp': 'Używaj tego tylko wtedy, gdy chcesz odejść od propozycji Plumme lub zarejestrować saldo otwarcia konta zysków i strat przy zmianie systemu.',
  'asset.changeTaxElection': 'Zmień wybór podatkowy',
  'asset.taxElectionCurrentDefault': 'Automatyczna propozycja Plumme dla wybranego salda wynosi {amount}.',
  'asset.taxElectionOverrideRequired': 'Podaj kwotę, która ma odbiegać od automatycznej propozycji.',
  'asset.taxElectionReasonRequired': 'Napisz, dlaczego nadpisujesz automatyczną propozycję.',
  'asset.automationStatusOff': 'Wyłączone. Włącz raz, aby automatycznie księgować zakończone miesiące.',
  'asset.automationStatusReview': 'Wstrzymane. Sprawdź plany i ponownie zatwierdź automatyzację.',
  'asset.automationApprovalNote': 'Zatwierdzono automatyczne miesięczne księgowanie amortyzacji bilansowej.',
  'asset.automationApprovalFailed': 'Środek trwały został zarejestrowany, ale nie udało się włączyć automatycznego księgowania miesięcznego. Sprawdź status na stronie środków trwałych.',
  'asset.autoPostingActive': 'Automatyczne księgowanie miesięczne jest domyślne',
  'asset.monthlyDepreciationPreview': 'Amortyzacja bilansowa wyniesie około {amount} miesięcznie i będzie księgowana automatycznie po rejestracji.',
  'asset.monthlyDepreciationPreviewOff': 'Automatyczne księgowanie miesięczne jest wyłączone w Ustawienia – Księgowość.',
  'asset.manageInSettings': 'Zarządzaj w ustawieniach',
  'asset.special.financing': 'Kredyty i finansowanie',
  'asset.special.tradeIn': 'Rozliczenie w ramach wymiany',
  'asset.special.partialSale': 'Częściowa sprzedaż',
  'asset.special.property': 'Nieruchomości',
  'asset.specialCasesHelp': 'Praktyczne wskazówki dla sytuacji wymagających osobnej dokumentacji lub podziału.',
  'asset.automationStopNote': 'Automatyczne miesięczne księgowanie zatrzymane przez użytkownika.',
  'asset.unpostedDepreciation': 'Pozostało do zaksięgowania: {amount} do {date} włącznie.',
  'asset.importedHistory': 'Zaimportowana historia',
  'asset.importedHistoryHelp': 'Historyczny środek trwały zaimportowany z innego systemu księgowego. Wartości i amortyzacja są wyświetlane na podstawie śladu importu i nie są ponownie księgowane w Plumme.',
  'asset.edit': 'Edytuj środek trwały',
  'asset.registerSold': 'Oznacz jako sprzedany',
  'asset.moreOptions': 'Więcej opcji',
  'asset.reclassifyPurchase': 'Zamień na zwykły zakup',
  'asset.reclassifyTitle': 'Zamień na zwykły zakup',
  'err.asset.reverseReclassificationBeforeAcquisition': 'Wycofaj przeklasyfikowanie środka trwałego, zanim anulujesz dowód zakupu.',
  'asset.acquisitionLockedTitle': 'Dlaczego działania są zablokowane?',
  'asset.acquisitionLockedSold': 'Środek trwały został sprzedany. Sprzedaż trzeba wycofać, zanim będzie można skorygować zakup.',
  'asset.acquisitionLockedReview': 'Księgowanie musi zostać wyjaśnione, zanim będzie można skorygować zakup.',
  'asset.acquisitionLockedDepreciation': 'Środek trwały ma zaksięgowaną amortyzację. Dowodu zakupu ani środka trwałego nie można bezpośrednio zmienić ani usunąć. Jeśli zakup powinien zostać ujęty w kosztach, użyj korekty poniżej. Jeśli sam zakup jest błędny, amortyzację i dowód zakupu trzeba skorygować identyfikowalnymi księgowaniami storno.',
  'asset.correctCapitalization': 'Skoryguj błędną aktywację',
  'asset.correctCapitalizationBody': 'Używaj tego tylko wtedy, gdy zakup jest prawidłowy, ale powinien zostać ujęty w kosztach. Amortyzacja zostanie wycofana, a koszt nabycia przeniesiony na wybrane konto kosztowe w jednym zapisie. Oryginalne dowody księgowe, VAT i płatności zostają zachowane. Data musi przypadać po ostatniej amortyzacji w tym samym otwartym roku. Amortyzacja grupowa i odpisy aktualizujące wymagają osobnej weryfikacji.',
  'asset.reclassifyBody': 'Użyj tej opcji, gdy zakup nie powinien był zostać zarejestrowany jako aktywo. Oryginalny dowód księgowy zostaje zachowany. Osobny dowód korygujący przenosi koszt nabycia na wybrane konto kosztów w wybranym przez Ciebie dniu.',
  'asset.expenseAccount': 'Konto kosztów',
  'asset.correctionReason': 'Powód',
  'asset.correctionReasonPh': 'Np. poniżej progu kwotowego / błędna klasyfikacja',
  'asset.reclassifiedToast': 'Zakup został przekształcony w zwykły zakup.',
  'asset.reclassifyError': 'Nie udało się przekształcić aktywa w zwykły zakup.',
  'asset.annulPurchase': 'Anuluj dowód zakupu',
  'asset.annulTitle': 'Anuluj dowód zakupu',
  'asset.annulBody': 'Użyj tej opcji, gdy cały dowód zakupu jest błędny lub zaksięgowany podwójnie. Dowód nie zostanie usunięty z historii, ale księgowanie zostanie wyłączone z raportów i zestawienia obrotów i sald.',
  'asset.annulLocksTitle': 'Może być zablokowane przez VAT, bank lub zamknięcie roku',
  'asset.annulLocksBody': 'Jeśli okres został złożony, uzgodniony z bankiem lub zamknięty rocznie, należy go otworzyć lub skorygować, zanim dowód będzie można anulować.',
  'asset.annulReasonPh': 'Np. podwójnie zaksięgowany dowód / błędnie przesłany plik',
  'asset.annulledToast': 'Dowód zakupu został anulowany.',
  'asset.annulError': 'Nie udało się anulować dowodu zakupu.',
  'asset.markMistaken': 'Oznacz aktywo jako zarejestrowane błędnie',
  'asset.saleDate': 'Data sprzedaży',
  'asset.bookValueShort': 'Wartość księgowa',
  'asset.saleAmountExVat': 'Kwota sprzedaży bez VAT',
  'asset.vat': 'VAT',
  'asset.howRegisterSale': 'Jak chcesz zarejestrować sprzedaż?',
  'asset.continueTitle': 'Kontynuować?',
  'asset.continue': 'Kontynuuj',
  'asset.undoDeleteTitle': 'Cofnąć usunięcie?',
  'asset.undoDelete': 'Cofnij usunięcie',
  'asset.undoSaleTitle': 'Cofnąć sprzedaż?',
  'asset.undoSale': 'Cofnij sprzedaż',
  'asset.saveDraft': 'Zapisz szkic',
  'asset.name': 'Nazwa środka trwałego',
  'asset.namePh': 'Np. MacBook Pro 16"',
  'asset.depreciationNote': 'Ten zakup zostanie zarejestrowany jako środek trwały i amortyzowany przy zamknięciu roku.',
  'asset.supplierPurchase': 'Zakup od dostawcy',
  'asset.supplier': 'Dostawca',
  'asset.invoiceNumber': 'Numer faktury',
  'asset.invoiceNumberPh': 'Np. 100245',
  'asset.lines': 'Pozycje',
  'asset.linePh': 'Np. maszyna, komputer lub narzędzia',
  'asset.account': 'Konto środka trwałego',
  'asset.vatRate': 'Stawka VAT',
  'asset.addLine': 'Dodaj pozycję',
  'asset.paidBy': 'Zapłacono z',
  'asset.payOperating': 'Rachunek bieżący - 1920',
  'asset.payCash': 'Gotówka - 1900',
  'asset.payPrivate': 'Prywatnie - 2060',
  'asset.payLoan': 'Zapłacono z zaciągniętego kredytu - 2250',
  'asset.splitPayment': 'Podziel płatność',
  'asset.partPayments': 'Płatności częściowe',
  'asset.fullPayment': 'Pełna płatność',
  'asset.addPartPayment': 'Dodaj płatność częściową',
  'asset.uploadFile': 'Prześlij plik',
  'asset.dropFiles': 'Przeciągnij i upuść pliki tutaj lub wybierz je z komputera.',
  'asset.removeAttachment': 'Usuń załącznik',
  'asset.sold': 'Sprzedane',
  'asset.depreciated': 'Zamortyzowane',
  'asset.active': 'Aktywne',
  'asset.viewsTitle': 'Widoki',
  'asset.viewsHelp': 'Filtruj listę: „Aktywne” to aktywa z pozostałą wartością księgową, które są nadal amortyzowane, „Zamortyzowane” są w pełni odpisane do 0, „Sprzedane” zostały zbyte, a „Wszystkie” pokazuje wszystko.',
  'asset.noneInView': 'Brak aktywów w tym widoku',
  'asset.fromPurchase': 'Zarejestruj na podstawie zakupu',
  'asset.group': 'Grupa',
  'asset.groupHelp': 'Grupa saldowa określa stawkę amortyzacji — jaką część można co roku zamortyzować podatkowo. Np. grupa C (samochody dostawcze) i grupa D (maszyny, wyposażenie) mają różne stawki ustalone przez Skatteetaten.',
  'asset.depreciatedHelp': 'Kwota dotychczas ujęta w kosztach — czyli jaka część kosztu nabycia została już zamortyzowana na przestrzeni lat. Koszt nabycia minus amortyzacja daje wartość księgową.',
  'asset.bookValue': 'Wartość księgowa',
  'asset.bookValueHelp': 'Obecna pozostała wartość aktywa w księgach — koszt nabycia minus dotychczasowa amortyzacja. To kwota, która pozostaje do zamortyzowania w kolejnych latach.',
  'asset.declining': 'Amortyzacja degresywna i formularze',
  'asset.decliningHelp': 'Amortyzacja degresywna (saldowa) to najczęstsza metoda amortyzacji: co roku amortyzuje się stały procent pozostałego salda w każdej grupie. Tabela pokazuje podstawę dla każdej grupy saldowej. RF-1084 i RF-1217 to formularze Skatteetaten dotyczące amortyzacji i różnic przejściowych — Plumme wypełnia je na podstawie tych danych.',
  'asset.opening': 'Saldo początkowe',
  'asset.additions': 'Nowe nabycia',
  'asset.disposals': 'Sprzedaż',
  'asset.movements': 'Ruchy',
  'asset.depreciation': 'Amortyzacja',
  'asset.closing': 'Saldo końcowe',
  'asset.groupDFallback': 'Grupa saldowa D – samochody osobowe, maszyny i wyposażenie',
  'asset.attachmentFallback': 'Załącznik',
  'asset.pageTitleHelp': 'Aktywa (środki trwałe) to większe rzeczy, które firma posiada i używa przez kilka lat — komputer, pojazd, maszyny, wyposażenie. Nie ujmuje się ich od razu w kosztach, lecz amortyzuje: koszt jest rozkładany na kolejne lata okresu użytkowania. Tutaj Plumme pilnuje za Ciebie amortyzacji i wartości do formularzy.',
  'asset.pageAddHelp': 'Zarejestruj nowe aktywo, gdy pojedynczy środek trwały ma koszt nabycia co najmniej 30 000 kr i przewidywany okres użytkowania co najmniej trzech lat. Próg nie dotyczy samej sumy faktury.',
  'asset.emptyText': 'Aktywa to rzeczy, które firma posiada i używa przez kilka lat — np. komputer, pojazd lub narzędzia. Są co roku częściowo amortyzowane. Zarejestruj aktywo na podstawie zakupu, a my będziemy pilnować amortyzacji i wartości do formularzy.',
  'asset.tabActive': 'Aktywne ({n})',
  'asset.tabDepreciated': 'Zamortyzowane ({n})',
  'asset.tabSold': 'Sprzedane ({n})',
  'asset.tabAll': 'Wszystkie ({n})',
  'asset.colAsset': 'Aktywo',
  'asset.soldOnLabel': 'sprzedano {date}',
  'asset.acquiredInline': 'Nabyto {date}',
  'asset.groupRateInline': 'Grupa {group} · {rate} %',
  'asset.colAcquired': 'Data nabycia',
  'asset.colCost': 'Koszt nabycia',
  'asset.costInline': 'Koszt nabycia {amount}',
  'asset.colStatus': 'Status',
  'asset.decliningDescription': 'Podstawa amortyzacji degresywnej dla każdej grupy. RF-1084 / RF-1217 są pokazane jako odniesienia do formularzy w norweskiej logice podatkowej.',
  'asset.depreciationInline': 'Amortyzacja −{amount}',
  'asset.atYearEnd': 'Na koniec {year}',
  'asset.accountingValue': 'Wartość bilansowa',
  'asset.taxValue': 'Wartość podatkowa',
  'asset.temporaryDifference': 'Różnica przejściowa',
  'asset.noCustomer': 'Bez klienta',
  'asset.fallbackNoun': 'aktywo',
  'asset.saleLineDescription': 'Sprzedaż: {name}',
  'asset.deletedStatus': 'Usunięte',
  'asset.updateFailed': 'Nie udało się zaktualizować aktywa.',
  'asset.transitionSaved': 'Wartości przejściowe i ocena zostały zapisane.',
  'asset.transitionSaveFailed': 'Nie udało się zapisać wartości przejściowych.',
  'asset.soldPendingOther': 'Dokończ „Inną sprzedaż”, aby zarejestrować aktywo jako sprzedane',
  'asset.soldPendingInvoice': 'Utwórz fakturę, aby zarejestrować aktywo jako sprzedane',
  'asset.registeredSold': 'Aktywo zarejestrowano jako sprzedane',
  'asset.detailTitle': 'Aktywo: {name}',
  'asset.tabInfo': 'Informacje',
  'asset.tabDepreciationChanges': 'Amortyzacja / zmiany',
  'asset.tabForms': 'Formularze',
  'asset.purchaseDate': 'Data zakupu',
  'asset.purchasePrice': 'Cena zakupu',
  'asset.assetAccountLabel': 'Konto aktywa',
  'asset.missingValue': 'Brak',
  'asset.usefulLifeLabel': 'Ekonomiczny okres użytkowania',
  'asset.yearsCount': 'Lata: {n}',
  'asset.taxDepreciationRateLabel': 'Podatkowa stawka amortyzacji',
  'asset.impairmentAssessmentYear': 'Ocena utraty wartości {year}',
  'asset.noIndicators': 'Brak przesłanek',
  'asset.impairedAmount': 'Odpis aktualizujący {amount}',
  'asset.transitionHeading': 'Przejście na Plumme',
  'asset.transitionBody': 'Historyczne zaksięgowane wartości zostają zachowane. Zarejestruj osobno podatkową wartość początkową oraz plan dla kolejnych zamknięć roku.',
  'asset.registerTransitionValues': 'Zarejestruj wartości przejściowe',
  'asset.colYear': 'Rok',
  'asset.colType': 'Typ',
  'asset.colDescription': 'Opis',
  'asset.colAccountingChange': 'Zmiana bilansowa',
  'asset.colNewValue': 'Nowa wartość',
  'asset.sellTitle': 'Zarejestruj aktywo jako sprzedane: {name}',
  'asset.sellNoInvoice': 'Zarejestruj sprzedaż bez faktury',
  'asset.createInvoiceBtn': 'Utwórz fakturę',
  'asset.markSoldBtn': 'Oznacz jako sprzedane',
  'asset.gainOnSale': 'Zysk ze sprzedaży',
  'asset.lossOnSale': 'Strata na sprzedaży',
  'asset.sellMethodMarkDesc': 'Używane, gdy przychód ze sprzedaży został już zaksięgowany.',
  'asset.sellMethodOtherDesc': 'Otwiera Inną sprzedaż z wstępnie wypełnionym aktywem.',
  'asset.sellMethodInvoiceDesc': 'Otwiera nowy szkic faktury z aktywem jako pozycją.',
  'asset.sellHelperPrefix': 'Sprzedaż zmniejsza saldo amortyzacji w grupie {group}.',
  'asset.sellHelperMarkSuffix': 'Wybierz tę opcję tylko wtedy, gdy przychód został już zaksięgowany.',
  'asset.sellHelperOtherSuffix': 'Przeprowadzimy cię dalej, aby zaksięgować sam przychód ze sprzedaży.',
  'asset.continueDeleteBody': 'Użyj tej opcji tylko wtedy, gdy aktywo zostało zarejestrowane przez pomyłkę i nie ma być amortyzowane. Wykonane księgowania zamknięcia roku/amortyzacji należy odwrócić przed oznaczeniem aktywa jako usuniętego.',
  'asset.markedDeleted': 'Aktywo oznaczone jako usunięte',
  'asset.restoreDeleteBody': 'Aktywo stanie się ponownie aktywne i zostanie uwzględnione w grupie saldowej, wartości podatkowej i podstawie amortyzacji. Jeśli przeprowadzono zamknięcie roku lub zaksięgowano amortyzację, gdy aktywo było usunięte, sprawdź je i w razie potrzeby odwróć przed kontynuacją.',
  'asset.deleteUndone': 'Cofnięto usunięcie',
  'asset.restoreSaleBody': 'Aktywo stanie się ponownie aktywne, a sprzedaż zostanie usunięta z grupy saldowej i podstawy amortyzacji. Nie usuwa to ani nie koryguje faktury lub innej sprzedaży już zarejestrowanej w procesie sprzedaży. Sprawdź zamknięcie roku i księgowania amortyzacji, jeśli zostały utworzone po zarejestrowaniu sprzedaży.',
  'asset.saleUndone': 'Cofnięto sprzedaż',
  'asset.transitionTitle': 'Wartości przejściowe: {name}',
  'asset.saveAssessment': 'Zapisz ocenę',
  'asset.savingEllipsis': 'Zapisywanie…',
  'asset.planStartLabel': 'Początek planu w Plumme',
  'asset.remainingUsefulLifeYearsLabel': 'Pozostały okres użytkowania (lata)',
  'asset.taxOpeningValueYear': 'Podatkowa wartość początkowa {year}',
  'asset.impairmentToBeRecordedShort': 'Odpis aktualizujący do zarejestrowania',
  'asset.impairmentAmountLabel': 'Kwota odpisu aktualizującego',
  'asset.documentationLabel': 'Dokumentacja / uzasadnienie',
  'asset.importedHistoryUnchanged': 'Zaimportowana historia nie zostanie zmieniona. Plan zaczyna się od wartości księgowej na początek roku i jest prowadzony oddzielnie od wartości podatkowej.',
  'asset.nameRequired': 'Nazwa środka trwałego jest wymagana.',
  'asset.amountMustBePositive': 'Kwota musi być większa niż 0.',
  'asset.planFieldsInvalid': 'Podaj prawidłową datę oddania do używania, okres użytkowania i wartość rezydualną.',
  'asset.assessImpairmentRequired': 'Oceń przesłanki utraty wartości za {year}.',
  'asset.impairmentAmountRequired': 'Podaj kwotę odpisu aktualizującego.',
  'asset.draftContentRequired': 'Dodaj nazwę, pozycję lub załącznik przed zapisaniem szkicu.',
  'asset.updated': 'Zaktualizowano aktywo',
  'asset.registeredDepreciating': 'Zarejestrowano aktywo - amortyzacja przy zamknięciu roku',
  'asset.saveFailed': 'Nie udało się zapisać aktywa.',
  'asset.attachmentAdded': 'Dodano załącznik.',
  'asset.savingDots': 'Zapisywanie...',
  'asset.registerAssetBtn': 'Zarejestruj aktywo',
  'asset.bookDepreciationPanelTitle': 'Bilansowy plan amortyzacji',
  'asset.bookDepreciationPanelDesc': 'Plan określa wartość księgową. Grupa saldowa poniżej służy wyłącznie do celów podatkowych.',
  'asset.usefulLifeYearsFieldLabel': 'Okres użytkowania (lata)',
  'asset.noImpairmentIndicatorsOption': 'Brak przesłanek utraty wartości',
  'asset.impairmentToBeRecordedOption': 'Należy zarejestrować odpis aktualizujący',
  'asset.documentationPlaceholder': 'Krótkie uzasadnienie lub odwołanie do dokumentacji',
  'asset.supplierPurchaseHelp': 'Powiąż aktywo z dostawcą i numerem faktury, jeśli zakup pochodzi z faktury od dostawcy.',
  'asset.noDescriptionFallback': 'Bez opisu',
  'asset.amountModeGross': 'z VAT',
  'asset.amountModeNet': 'bez VAT',
  'asset.hideVoucher': 'Ukryj dokument',
  'asset.showVoucher': 'Pokaż dokument',
  'asset.reclassAcct6540': 'Wyposażenie',
  'asset.reclassAcct7700': 'Inny koszt',
  'asset.missingFileLink': 'Brak linku do pliku',
  'asset.cannotPreviewInBrowser': 'Nie można wyświetlić podglądu w przeglądarce.',
  'asset.automaticPostingExplanation': 'Amortyzacja jest księgowana automatycznie za każdy zakończony miesiąc. Plumme nadrabia brakujące miesiące bez żadnych działań z twojej strony.',
  'asset.automaticPostingNeedsReview': 'Automatyczna amortyzacja wymaga uwagi. Sprawdź plan aktywa lub skontaktuj się z pomocą techniczną. Plumme spróbuje ponownie po usunięciu rozbieżności.',
  'asset.automaticScopeUnsupported': 'Automatyczna amortyzacja jest obecnie dostępna tylko dla obsługiwanych norweskich konfiguracji księgowych.',
  'asset.automaticCorrectionRequired': 'Dokończ korektę planu amortyzacji po odwróceniu. Następnie automatyczne księgowanie będzie kontynuowane.',
  'asset.automaticPostingThrough': 'Ostatnia zaksięgowana amortyzacja: {date}.',
  'asset.automaticPostingPending': 'Pozostało {amount} do {date} włącznie. Plumme automatycznie pilnuje księgowania.',
  'err.nativeValidation.fixedAssetAcquisitionRegistration.1': 'Wybierz jedno istniejące nabycie do zarejestrowania.',
  'err.nativeValidation.fixedAssetAcquisitionRegistration.2': 'To nabycie jest już zarejestrowane jako środek trwały.',
  'err.nativeValidation.fixedAssetAcquisitionRegistration.3': 'Data rejestracji musi być zgodna z pierwotnym nabyciem.',
});
